import React, { ReactElement } from 'react';
import { FormulaireCreationEntite, PropsDeCreationEntite } from '../../Utils/FormulaireCreationEntite';
import { HistoriquePrixProduit } from '../../../../../../common/src/entities';
import { ChampsHistoriquePrixProduit } from './DetailsHistoriquePrix';
import { Alert } from 'react-bootstrap';
import { DateTime } from 'luxon';

export default function CreerProduitPrix(
    props: Partial<PropsDeCreationEntite<HistoriquePrixProduit>> & { initialValues?: HistoriquePrixProduit },
): ReactElement {
    const lastPrice = props.initialValues ? { ...props.initialValues } : undefined;
    const finalLastPriceWithoutId = {
        ...lastPrice,
        id: undefined,
        date_debut: DateTime.now().toFormat('yyyy-MM-dd'),
        fk_id_facturation: undefined,
    };
    return (
        <FormulaireCreationEntite
            texteEntete={(t: HistoriquePrixProduit) => (
                <small className="text-muted">Création d&apos;un nouveau prix</small>
            )}
            entite={HistoriquePrixProduit}
            {...props}
            valeursInitiales={finalLastPriceWithoutId}
        >
            {lastPrice ? (
                <>
                    <Alert variant="info">Les valeurs ci-dessous ont été puisées du prix précédent.</Alert>
                </>
            ) : (
                <></>
            )}

            <ChampsHistoriquePrixProduit />
        </FormulaireCreationEntite>
    );
}
